import reviewSaga from './reviews/reviewSaga';

export default [
    reviewSaga,
];



// WEBPACK FOOTER //
// ./src/sagas.js